export const DEFAULT_IN_NETWORK_ESTIMATES = {
  expectedSessionRate: 44,
  expectedEvaluationRate: 44,
  averageSessionPatientResponsibility: 21,
  averageEvalPatientResponsibility: 44,
  defaultDeposit: 50,
  isDefaultEstimates: true,
};

export const OUT_OF_NETWORK_ESTIMATES = {
  expectedSessionRate: 44,
  expectedEvaluationRate: 44,
  averageSessionPatientResponsibility: 88,
  averageEvalPatientResponsibility: 175,
  defaultDeposit: 88,
  isDefaultEstimates: true,
};
